import { Component, Output, EventEmitter, Input, OnDestroy, AfterViewInit } from '@angular/core';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export interface DialogSimpleTextContent {
  title: string;
  titleId?: string;
  paragraph?: string;
  multipleContent?: boolean;
  paragraphId?: string;
  confirmButton?: string;
  confirmButtonId?: string;
  cancelButton?: string;
  cancelButtonId?: string;
}

@Component({
  selector: 'app-dialog-simple',
  templateUrl: './dialog-simple.component.html',
  styleUrls: ['./dialog-simple.component.scss'],
  standalone: false
})
export class DialogSimpleComponent implements AfterViewInit, OnDestroy {
  @Input()
  textContent: DialogSimpleTextContent;

  @Input()
  hasCloseButton = true;

  @Input()
  icon: string;

  @Input()
  disableBodyScroll = false;

  @Output()
  close: EventEmitter<void> = new EventEmitter();

  @Output()
  confirm: EventEmitter<void> = new EventEmitter();

  ngAfterViewInit() {
    if (this.disableBodyScroll) {
      disableBodyScroll();
    }
  }

  ngOnDestroy(): void {
    if (this.disableBodyScroll) {
      clearAllBodyScrollLocks();
    }
  }
}
